export default "__VITE_ASSET__DHylt_$D__"